import { authFetch, API_URL, clearAuthSession, getAuthHeaders } from "../../utils/auth";

const BASE = `${API_URL}/settings/`;

function headers(json = true) {
  const h = { Accept: "application/json", ...getAuthHeaders() };
  if (json) h["Content-Type"] = "application/json";
  return h;
}

function firstError(data) {
  if (!data || typeof data !== "object") return "";
  for (const [field, value] of Object.entries(data)) {
    if (Array.isArray(value) && value.length) return `${field}: ${String(value[0])}`;
    if (value && typeof value === "object") {
      const nested = firstError(value);
      if (nested) return `${field}: ${nested}`;
    }
    if (typeof value === "string") return field === "detail" ? value : `${field}: ${value}`;
  }
  return "";
}

async function parse(request) {
  const response = await request;
  const type = response.headers?.get("content-type") || "";
  const data = type.includes("application/json")
    ? await response.json()
    : { detail: "The request could not be completed." };

  if (response.status === 401) clearAuthSession();

  if (!response.ok) {
    const error = new Error(firstError(data) || "Settings request failed.");
    error.data = data;
    error.status = response.status;
    throw error;
  }

  return data;
}

function patch(section, payload) {
  const isForm = payload instanceof FormData;
  return parse(
    authFetch(`${BASE}${section}/`, {
      method: "PATCH",
      headers: headers(!isForm),
      body: isForm ? payload : JSON.stringify(payload),
    })
  );
}

export const fetchSettings = () => parse(authFetch(BASE, { headers: headers(false) }));
export const updateGeneralSettings = (payload) => patch("general", payload);
export const updateOrderingSettings = (payload) => patch("ordering", payload);
export const updatePaymentSettings = (payload) => patch("payments", payload);
export const updateNotificationSettings = (payload) => patch("notifications", payload);
export const updateMarketingSettings = (payload) => patch("marketing", payload);
export const updateStorefrontSettings = (payload) => patch("storefront", payload);
export const updatePolicySettings = (payload) => patch("policies", payload);
export const updateOperationalSettings = (payload) => patch("operations", payload);
export const updateFeatureSettings = (payload) => patch("features", payload);
export const fetchIntegrationStatus = () => parse(authFetch(`${BASE}integrations/`, { headers: headers(false) }));
export const fetchSettingsHealth = () => parse(authFetch(`${BASE}health/`, { headers: headers(false) }));
